import { UseRebateConditionsFormReturnType } from '../hooks/useRebateConditionsForm'
import { FormInstance } from 'antd/lib/form/hooks/useForm'
import { IRebateConditionForm } from '../types'

export const defaultRebateConditionsForm: UseRebateConditionsFormReturnType = {
  form: {} as FormInstance<IRebateConditionForm>,
  type: 'no_rebate',
  isChanged: false,
  applyToHospitals: false,
  hasFormChanges: false,
  hasValidationError: false,
  handleFinishForm: () => Promise.resolve(),
  handleCancelForm: () => undefined,
  handleChangeForm: () => undefined,
  hospitals: [],
  hospitalRebates: [],
  thresholdPeriodOptions: [],
  setIsChanged: () => undefined,
  isAmountProvided: false,
  isBaselineSpendProvided: false,
  saveFormAndUpdateTiers: () => Promise.resolve(false),
  tiers: []
}
